import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ContactList.styled";

const ContactJob = (props) => {
  const { t, data, status } = props;

  return (
    <>
      {status === 1 && (
        <DivBackgroundFullOpacity>{data}</DivBackgroundFullOpacity>
      )}
      {status !== 1 && (
        <DivBackgroundLowOpacity>{data}</DivBackgroundLowOpacity>
      )}
    </>
  );
};

ContactJob.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ContactJob);
